var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var ActivePageSection = require('common/util/ActivePageSection');

var COCInternalDashboardView = require('../views/COCInternalDashboardView');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);

  $.when()
    .done(function() {
      NavUtils.navigate('coc/dashboard');

      Scaffold.content.show(
        new COCInternalDashboardView({
          model: new Backbone.Model({})
        })
      );

      ActivePageSection.empty();
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
